import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
import WidgetStepPreview
  from '@components/Widgets/_global/WidgetStepPreview/WidgetStepPreview.vue'

export default {
  name: 'StepItems',
  components: {
    WidgetStepPreview,
    draggable,
  },
  computed: {
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },
    targetWidgetType() {
      return this.$store.getters['campaign/widget/targetWidgetType']
    },
    targetWidget() {
      return this.$store.getters['campaign/widget/targetWidget']
    },
    steps() {
      return this.$store.getters['campaign/widget/targetWidgetSteps']
    },
    stepsList: {
      get() {
        return this.$store.getters['campaign/widget/targetWidgetStepsList']
      },
      set(value) {
        this.updateStepOrder(value)
      },
    },
  },
  data() {
    return {
      isWidgetMenuModalOpen: false,
      dragTargetStepID: '',
      drag: false,
      actionButtonMouseDown: false,
      customSteps: {
        voucherStepID: '',
        wheelSpinBtnStepID: '',
      },
    }
  },
  created() {
    if (this.targetWidgetType === 'fortuneWheel') {
      // filter voucher and wheelspin steps
      this.setCustomSteps()
    }
  },
  methods: {
    ...mapActions('campaign/step', [
      'setTargetStep',
      'cloneStep',
      'addStep',
      'deleteStep',
      'updateStepOrder',
    ]),
    ...mapActions('campaign/contentItem', ['clearTargetContentItem']),
    triggerSetTargetStep(id) {
      this.clearTargetContentItem()
      this.setTargetStep(id)
    },
    triggerAddStep(index) {
      this.clearTargetContentItem()
      this.addStep(index)
    },
    triggerCloneStep(id, index) {
      /* This function exists only because a direct @click trigger doesn't support
         passing object with vars e.g. cloneWidget({ id, index }) */
      this.cloneStep({ id, index })
    },
    triggerDeleteStep(id, index) {
      /* This function exists only because a direct @click trigger doesn't support
         passing object with vars e.g. cloneWidget({ id, index }) */
      this.$msgbox
        .confirm("Are you sure you'd like to delete this page?", 'Warning', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          showCancelButton: true,
          type: 'warning',
        })
        .then(() => {
          this.deleteStep({ id, index })
        }).catch(() => {});
    },
    chooseDrag(evt, clear = false) {
      if (clear) {
        // dragging has stopped
        this.actionButtonMouseDown = false
        this.dragTargetStepID = ''
      } else {
        this.dragTargetStepID = this.stepsList[evt.oldIndex]
      }
    },
    setCustomSteps() {
      this.stepsList.forEach((id) => {
        Object.entries(this.steps[id].contentItems).forEach(([key, value]) => {
          if (value.type === 'voucher') {
            this.customSteps.voucherStepID = id
          } else if (value.type === 'button' && value.settings.action === 'wheelSpin') {
            this.customSteps.wheelSpinBtnStepID = id
          }
        })
      })
    },
  },
}
